import { BaseModel, Default } from '@red/data-access';
import { Expose, Transform, Type } from 'class-transformer';
import { DynamicReportType, IDynamicReportConfig, IOption, IParameter, OPERATOR } from './dynamic-report-general.interface';
import { CustomColumnModel } from './dynamic-report-general.model';
import { ExecljsParameterValueType, IExceljsParameterControlType, normalizeValueByDefaultValueParameter, normalizeValueByType } from '@shared/components/exceljs-viewer';
import * as moment from 'moment';

export class ParameterDto extends BaseModel implements IParameter {
  @Expose()
  displayName!: string;

  @Expose()
  alias!: string;

  @Expose()
  column!: string;

  @Expose()
  @Transform(({ value }) => value ? value : undefined)
  columnType!: string;

  @Expose()
  type!: IExceljsParameterControlType;

  @Expose()
  valueType!: ExecljsParameterValueType;

  @Expose()
  @Transform(({ obj, value }) => {
    let _value = value;
    if (typeof value === 'object' && obj.type !== 'date/range') {
      _value = value?.value;
    }
    if (value && Array.isArray(value)) {
      _value = [];
      value?.filter(e => !!e)?.forEach((item: any) => {
        _value?.push(item?.value);
      });
    }
    if (obj.type === 'date/range') {
      _value = {
        start: value?.start ? moment(value?.start).startOf('day') : null,
        end: value?.end ? moment(value?.end).endOf('day') : null,
      };
      return _value
    } else {
      return typeof value !== 'undefined' ? normalizeValueByType(normalizeValueByDefaultValueParameter(_value, obj), obj) : obj.default;
    }
  })
  value!: any;

  @Expose()
  default?: any;

  @Expose()
  options?: IOption[];

  @Expose()
  isVisible!: boolean;

  @Expose()
  templateRef?: string;

  @Expose()
  isEditable?: boolean;

  @Expose()
  operator?: OPERATOR;

  @Expose()
  operators?: OPERATOR[];
}

export class DynamicReportGeneralDto extends BaseModel {
  @Expose()
  id!: number;

  @Expose()
  @Transform(({ value }) => value?.trim())
  name!: string;

  @Expose()
  @Default('')
  description!: string;

  @Expose()
  reportType!: DynamicReportType;

  @Expose()
  isActive?: boolean;

  @Expose()
  isPublic?: boolean;

  @Expose()
  @Type(() => CustomColumnModel)
  @Transform(({ value }) => value?.filter((e: CustomColumnModel) => !!e))
  customColumns!: CustomColumnModel[];

  @Expose()
  @Type(() => ParameterDto)
  parameters!: ParameterDto[];

  @Expose()
  config?: IDynamicReportConfig;
}
export class PreviewDynamicReportDto extends BaseModel {
  @Expose()
  reportType!: DynamicReportType;

  @Expose()
  @Type(() => CustomColumnModel)
  @Transform(({ value }) => value?.filter((e: CustomColumnModel) => !!e))
  customColumns!: CustomColumnModel[];

  @Expose()
  @Type(() => ParameterDto)
  parameters!: ParameterDto[];

  @Expose()
  config!: IDynamicReportConfig;
}